import React from 'react';
import './ReportAnalysisStatusView.css';

function ReportAnalysisStatusView({ t, variant, error }) {
  if (variant === 'analyzing') {
    return (
      <>
        <h4>{t('report_analyzing_title')}</h4>
        <div className="progress-placeholder">
          <p>{t('report_preparing_report')}</p>
        </div>
      </>
    );
  }

  if (variant === 'error') {
    return (
      <>
        <h4>{t('report_analysis_error_title')}</h4>
        <p>{t('report_automics_failed')}</p>
        <div className="progress-placeholder progress-placeholder--error">
          <p className="progress-placeholder-message progress-placeholder-message--error">{error}</p>
        </div>
      </>
    );
  }

  return (
    <>
      <h4>{t('report_session_completed_title')}</h4>
      <p>{t('report_transcript_saved')}</p>
    </>
  );
}

export default ReportAnalysisStatusView;
